
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import dayjs from "dayjs";
import { emptyToLine } from "@common/src/utils/common";
import { addCurrencyUnit } from "@common/src/utils/tools";
const store = namespace("store");

@Component({})
export default class SettlementPrint extends Vue {
  @Prop({ type: Object, default: () => {} })
  data: any;
  @store.State storeData;
  dayjs = dayjs;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  get orderData() {
    return this.data;
  }
  get checkList() {
    return [
      {
        serviceName: this.orderData.templateName,
        technicianName: this.orderData.technicianName
      }
    ];
  }
}
